import _ from 'lodash';
import { createSelector } from 'reselect';
import columnAndRecordConfigsSelectorFactory from './dataTable/columnAndRecordConfigsFactory';
import { FIELD_GROUP_ALX_FIELDS } from '../../consts';

export const selectorClaimDataTableAlxColumns = createSelector(
  [
    columnAndRecordConfigsSelectorFactory([
      'claimColumnConfigsBasedOnState',
      FIELD_GROUP_ALX_FIELDS
    ]),
    columnAndRecordConfigsSelectorFactory('fieldGroupsNumericalValues')
  ],
  (alxColumnConfigsBasedOnState, fieldGroupsNumericalValues) => {
    const fieldGroupsStringValues = _.invert(fieldGroupsNumericalValues);
    const columns = [];

    _.map(alxColumnConfigsBasedOnState, alxColumnConfig => {
      const {
        column_label,
        field_group,
        field_name,
        has_filter,
        interactive,
        order,
        visible,
        width
      } = alxColumnConfig;

      if (!visible) {
        return;
      }

      columns.push({
        columnHasFilter: has_filter,
        columnInteractive: interactive,
        columnLabel: column_label,
        columnVisible: visible,
        columnWidth: width,
        fieldGroup: fieldGroupsStringValues[field_group],
        fieldName: field_name,
        order: order
      });
    });

    return _.orderBy(columns, 'order');
  }
);

export default selectorClaimDataTableAlxColumns;
